import { Icon } from '@pwc/pwc-deals-ui';
import styles from './CloseButtonSearch.module.scss';

type Props = {
  onClick: () => void;
};

export const CloseButtonSearch = ({ onClick }: Props) => (
  <button type="button" className={styles.button} onClick={onClick}>
    <Icon name="circle-delete" width="24" className="fill icon-grey" />
  </button>
);
